import React from 'react'
import {
    AspectRatio,
    Box,
    HStack,
    Flex,
    Img,
    Text,
    Button,
    useMultiStyleConfig,
    Portal,
} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'
import {getDamImageUrl, getGlobalLink} from '../../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {useHeaderRef} from '../../_app'
import {useProducts} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PlpStickyBar = ({data}) => {
    const headerRef = useHeaderRef()
    const styles = useMultiStyleConfig('StickyMenu', {variant: 'plpSticky'})
    const {locale} = useMultiSite()
    const categoriesData = useGetCategoriesData()
    const {data: productsData} = useProducts(
        {
            parameters: {
                ids:
                    data?.cta?.productsfcc?.data?.length > 0 ? data.cta.productsfcc.data[0].id : '',
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'plp-sticky-index',
            },
        },
        {
            enabled: data?.cta?.productsfcc?.data?.length > 0,
        },
    )
    const {label, url, isAbsolute} = getGlobalLink({
        link: data?.cta,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })
    const plpStickyBarTitle = data?.editorial_title
    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: url,
          }

    const imageUrls = [
        getDamImageUrl(data?.image_1),
        getDamImageUrl(data?.image_2),
        getDamImageUrl(data?.image_3),
    ]

    return (
        <Portal containerRef={headerRef}>
            <Box data-testid="sticky-menu" {...styles.stickyBar}>
                <Flex layerStyle="full-width" {...styles.stickyBarContent}>
                    <HStack {...styles.imageContainer}>
                        {imageUrls.map((url, index) =>
                            url ? (
                                <AspectRatio key={index} ratio={75 / 85} {...styles.productImage}>
                                    <Img
                                        src={url}
                                        alt={
                                            data && data[`image_${index + 1}`]?.description
                                                ? data[`image_${index + 1}`]?.description
                                                : ''
                                        }
                                    />
                                </AspectRatio>
                            ) : null,
                        )}
                    </HStack>
                    <Text {...styles.productText}>{plpStickyBarTitle}</Text>
                    {label && url && (
                        <Box {...styles.buttonContainer}>
                            <Button
                                w={'full'}
                                variant="primary"
                                {...buttonProps}
                                {...styles.buttonLabel}
                            >
                                {label}
                            </Button>
                        </Box>
                    )}
                </Flex>
            </Box>
        </Portal>
    )
}

PlpStickyBar.propTypes = {
    data: PropTypes.object,
}

export default PlpStickyBar
